import tailwindConfig from '../../../tailwind.config';

export const BOX_PHOTO_FORMATS_LABEL = 'JPG, JPEG, PNG, WEBP, HEIC';
export const BOX_PHOTO_MAX_SIZE_MB = 15;

export const APP_ROOT_SELECTOR = '#app' 


export const ICONS = {
    MY_SPACE: 'myspace_icon',
    ADDRESS_BOOK: 'address_icon',
    SETTINGS: 'settings_icon',
    HELP: 'question-mark-icon',
    CART: 'cart_icon',
    PROFILE: 'profile_icon',
    SECURE: 'secure_icon',
    REFER_FRIEND: 'refer_friend_icon',
    CARD: 'card_icon',
    RADIO_SELECT: 'radio_selected_icon',
    RADIO: 'radio_icon',
    VISA_CARD: 'visa_icon',
    LOCATION: 'location_icon',
    LOCATION_GREY: 'location_grey_icon',
    CLOSE: 'close_icon',
    ARROW_DOWN: 'arrow_down_icon',
    ARROW_UP: 'arrow_up_icon',
    GOOGLE: 'google_icon',
    APPLE: 'apple_icon',
    LOCATION2: 'location_icon2',
    PLUS: 'plus_icon',
    DELETE: 'delete_icon',
    LOADING: 'icons-spinners-i-os',
    LOADING_BLACK: 'icons-spinners-i-os--black',
    MASTERCARD_CARD: 'mastercard_icon',
    DISCOVER_CARD: 'discover_icon',
    AMEX_CARD: 'amex_icon',
    GRAY_CARD: 'card_gray_icon',
    ONE_ICON: 'one_icon',
    TWO_ICON: 'second_icon',
    THIRD_ICON: 'third_icon',
    FOURTH_ICON: 'fourth_icon',
    BACK_ICON: 'back_icon',
    POSTER: 'ikea_text_poster',
    MINT_ONE_ICON: 'mint_one_icon',
    MINT_TWO_ICON: 'mint_two_icon',
    MINT_THREE_ICON: 'mint_three_icon',
    MINT_FOUR_ICON: 'mint_four_icon',
    BOX_ICON: 'box_icon',
    BOX_CONTENT_ICON: 'box_content_icon',
    EDIT_ICON: 'edit_icon',
    ADD_ICON: 'add_icon',
    COPY_ICON: 'copy_icon',
    SCHEDULE_ICON: 'schedule_icon',
    WARNING_ICON: 'warning_icon',
    WARNING_ORANGE: 'warning_icon_orange',
    WEAPON_ICON: 'weapon_icon_w',
    WHITE_WARNING_ICON: 'warning_icon_w',
    THC_ICON: 'thc_icon_w',
    LIQUIDS_ICON: 'liquids_icon_w',
    ILLEGAL_ICON: 'illegal_icon_w',
    FOOD_ICON: 'food_icon_w',
    UPS_ICON: 'ups_icon',
    MINT_SCHEDULE_ICON: 'mint_schedule_icon',
    ARROW_LEFT: 'arrow_left',
    ARROW_RIGHT: 'arrow_right',
    STORE_ICON: 'warehouse_icon',
    CAR_ICON: 'car_icon',
    MINT_CAR_ICON: 'mint_car_icon',
    ROUTE_PREVIEW_ICON: 'route_preview_icon',
    WHITE_ROUTE_ICON: 'route_icon_white',
    ON_WAY_ICON: 'on_way_icon',
    GREY_BOX: 'grey_box_icon',
    UPLOAD_ICON : 'upload_icon',
    SPACE_ICON : 'space_icon',
    WHITE_ADD_ICON : 'white_add_icon',
    MY_SPACE_DARK : 'myspace_dark_icon',
    REFER_FRIEND_DARK : 'refer_friend_dark_icon',
    LEARN_MORE : 'learn_more_icon',
    LEARN_MORE_DARK : 'learn_more_dark_icon',
    SETTINGS_DARK :'settings_dark_icon',
    SORT : 'sort_icon',
    CHEVRON_LEFT : 'chevron_left_icon',
    MINT_PROFILE : 'mint_profile_icon',
    LOGOUT_ICON : 'logout_icon',
    LOGOUT_ICON_HOVER : 'logout_icon_hover',
    USER_PFP_ICON : 'user_pfp_icon',
    GREY_EDIT_ICON : 'grey_edit_icon',
    MINT_PLUS_ICON : 'mint_plus_icon',
    LIGHT_UPLOAD_ICON : 'upload_icon_light',
   DISABLE_SCHEDULE_ICON : 'disable_schedule_icon',
   WHATSUP_ICON : 'whatsup_icon',
   FACEBOOK_ICON : 'facebook_icon',
   MAIL_ICON : 'mail_icon',
   MESSAGE_ICON : 'messaging_icon',
   X_ICON : 'x_icon',
   SUPPORT_CHAT_ICON : 'support_chat_icon',
   SUPPORT_CHAT_GREEN_ICON : 'support_chat_green_icon',
   EDIT_BOX_ICON : 'edit_box_icon',
    MINT_SUPPORT_CHAT_ICON : 'mint_support_chat_icon',
    MINT_HELP_ICON : 'mint_help_icon',
    MINT_MAIL_ICON : 'mint_mail_icon',
    MORE : 'more',
    TURA_MSG_ICON:'tura_msg_icon',
   RETRIEVE_CONFIRM :'retrieve_confirm_icon',
   CALENDER_ICON : 'calender_icon',
    ERROR_ICON : 'error_icon',
    FAST_ORDER_ERROR_ICON : 'erroricon',
    SUCCESS_ICON : 'success_icon',
    CORRECT_ICON : 'correct_icon',
   CAMERA_ICON : 'camera_icon',
   SUPPORT_CHAT_GRAY_ICON : 'support_chat_icon_gray',
   STAR_ICON : 'star_icon',
   BELL : 'bell'
};


export const BOX_STATE = {
    GRACE_PERIOD_PROCESSING: 'Processing',
    TRACK: 'See Details',
    START_PACKING: 'Start Packing',
    CONTINUE_PACKING: 'Continue Packing',
    SEND_TO_SPACE: 'Send to Space',
    REQUEST: 'Request'
};

export const BOX_STATE_UI = {

    NOT_SELECTED : 'Not Selected',
    GRACE_PERIOD_PROCESSING: 'Processing',
    START_PACKING: 'Start Packing',
    CONTINUE_PACKING: 'Continue Packing',
    SEND_TO_SPACE: 'Send to Space',
    REQUEST: 'Request',
    ARRIVING : 'Arriving',
    SENDING : 'Sending'

}

export const TONE = {
  GRAY: 'gray',
  MINT: 'mint',

}

export const TONE_CLASS = {
  [TONE.GRAY]: 'bg-disable-bg text-brandNavy-muted',
  [TONE.MINT]: 'bg-brandMint-muted text-brandMint',

}

export const HEADER_UI_CONFIG = {

    [BOX_STATE_UI.GRACE_PERIOD_PROCESSING] : {
        title : {class : 'color'},
        tags : {
             shown : false
        },
        editButton : {
            shown : false
        },
        statusChip : {
            shown : true,
            text : 'Processing',
            icon : ICONS.GREY_BOX,
            tone : TONE.GRAY
        }
    },
    [BOX_STATE_UI.START_PACKING] : {
        title : {class : 'color'},
        tags : { 
             shown : true,
           
        },
        editButton : {
            shown : true,
            icon : ICONS.EDIT_ICON,
            class : 'bg-turquoise-primary'

        },
        statusChip : {
            shown : true,
            text : 'With me',
            icon : ICONS.GREY_BOX,
            tone : TONE.GRAY
        }
    },
    [BOX_STATE_UI.CONTINUE_PACKING] : {
  title : {class : 'color'},
        tags : { 
             shown : true,
             tone : TONE.MINT
        },
        editButton : {
            shown : true,
            icon : ICONS.EDIT_ICON,
            class : 'bg-turquoise-primary'
        },
        statusChip : {
            shown : true,
            text : 'With me',
            icon : ICONS.MY_SPACE,
            tone : TONE.MINT
        }
    },
    [BOX_STATE_UI.SEND_TO_SPACE] : {
  title : {class : 'color'},
        tags : { 
             shown : true,
             tone : TONE.MINT
        },
        editButton : {
            shown : true,
            icon : ICONS.EDIT_BOX_ICON,
            class : 'bg-turquoise-primary'
        },
        statusChip : {
            shown : true,
            text : 'With me',
            icon : ICONS.MY_SPACE,
            tone : TONE.MINT
        }
    },
    [BOX_STATE_UI.REQUEST] : {
  title : {class : 'color'},
        tags : { 
             shown : true,
             tone : TONE.GRAY
        },
        editButton : {
            shown : false,
        
        },
        statusChip : {
            shown : true,
            text : 'Stored',
            icon : ICONS.STORE_ICON,
            tone : TONE.GRAY
        }
    },
    [BOX_STATE_UI.ARRIVING] : {
  title : {class : 'color'},
        tags : { 
             shown : false,
          
        },
        editButton : {
            shown : false,
           
        },
        statusChip : {
            shown : true,
            text : "On it's way",
            icon : ICONS.ON_WAY_ICON,
            tone : TONE.GRAY
        }
    },
    [BOX_STATE_UI.SENDING] : {
  itle : {class : 'color'},
        tags : { 
             shown : true,
             tone : TONE.GRAY
        },
        editButton : {
            shown : false,
        
        },
        statusChip : {
            shown : true,
            text : "On it's way",
            icon : ICONS.ON_WAY_ICON,
            tone : TONE.GRAY
        }
    }


}



export const ICON_FOR_STATE = {
    [BOX_STATE.GRACE_PERIOD_PROCESSING]: ICONS.GREY_BOX,
    [BOX_STATE.TRACK]: ICONS.ON_WAY_ICON,
    [BOX_STATE.START_PACKING]: ICONS.MY_SPACE,
    [BOX_STATE.CONTINUE_PACKING]: ICONS.MY_SPACE,
    [BOX_STATE.SEND_TO_SPACE]: ICONS.MY_SPACE,
    [BOX_STATE.REQUEST]: ICONS.STORE_ICON
};

export const BOX_SUB_STATE = {
    ARRIVING_BOX: 'Arriving Box',
    ARRIVING_REQUEST: 'Arriving Request',
    SENDING: 'Sending'
};

export const CARD_BRAND_COLORS = {
    STRANGLE_HOLD_BLUE:
        tailwindConfig.theme.extend.colors['strangle-hold-blue'],
    SKY_BLUE: tailwindConfig.theme.extend.colors['blue-in-the-face'],
    MOUNTAIN_MEADOW: tailwindConfig.theme.extend.colors['mountain-meadow'],
    CARNATION_PINK: tailwindConfig.theme.extend.colors['carnation-pink'],
    MUSTARD: tailwindConfig.theme.extend.colors.mustard,
    TERRACOTTA: tailwindConfig.theme.extend.colors.terracotta,
    DEFAULT_NAVY: tailwindConfig.theme.extend.colors.navy.DEFAULT
};

export const CARD_BRAND = {
    MASTERCARD: 'mastercard',
    VISA: 'visa',
    DISCOVER: 'discover',
    AMEX: 'amex',
    SPACE: 'space'
};

export const CARD_BRAND_DETAILS = {
    [CARD_BRAND.MASTERCARD]: {
        image: require('/static/assets/images/misc/credit-cards-logos-mastercard.svg'),
        colors: [
            CARD_BRAND_COLORS.STRANGLE_HOLD_BLUE,
            CARD_BRAND_COLORS.SKY_BLUE
        ]
    },
    [CARD_BRAND.VISA]: {
        image: require('/static/assets/images/misc/credit-cards-logos-visa.svg'),
        colors: [
            CARD_BRAND_COLORS.CARNATION_PINK,
            CARD_BRAND_COLORS.MUSTARD,
            CARD_BRAND_COLORS.TERRACOTTA,
            CARD_BRAND_COLORS.SKY_BLUE
        ]
    },
    [CARD_BRAND.DISCOVER]: {
        image: require('/static/assets/images/misc/credit-cards-logos-discover.png'),
        class: 'h-[50px]',
        colors: [
            CARD_BRAND_COLORS.SKY_BLUE,
            CARD_BRAND_COLORS.CARNATION_PINK,
            CARD_BRAND_COLORS.MUSTARD,
            CARD_BRAND_COLORS.MOUNTAIN_MEADOW
        ]
    },
    [CARD_BRAND.AMEX]: {
        image: require('/static/assets/images/misc/credit-cards-logos-amex.png'),
        class: 'h-[50px]',
        colors: [
            CARD_BRAND_COLORS.MOUNTAIN_MEADOW,
            CARD_BRAND_COLORS.CARNATION_PINK,
            CARD_BRAND_COLORS.MUSTARD,
            CARD_BRAND_COLORS.SKY_BLUE,
            CARD_BRAND_COLORS.DEFAULT_NAVY
        ]
    },
    [CARD_BRAND.SPACE]: {
        image: require('/static/assets/images/misc/clouds-pink.png'),
        class: 'h-[50px]',
        colors: [ CARD_BRAND_COLORS.DEFAULT_NAVY ]
    }
};
